<app-navbar />
<main class="container relative md:py-32 py-24 min-h-screen max-w-3xl">
   <h1 class="text-3xl font-bold mb-6">{{ 'pages.shops-page.title' | translate }}</h1>

   @if (signedIn === false) {
      <div class="glass rounded-3xl p-6 flex flex-col gap-3 items-start" id="shops-login">
         <p>{{ 'pages.shops-page.loginRequired' | translate }}</p>
         <a routerLink="/login" [queryParams]="{ next: loginNext }"
            class="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold rounded-xl px-6 py-3 transition">
            {{ 'components.login-link.login' | translate }}
         </a>
      </div>
   } @else if (signedIn === null) {
      <!-- Still finding out who is signed in -->
      <div class="spinner" role="status" [attr.aria-label]="'pages.shops-page.loading' | translate"></div>
   } @else if (signedIn) {
      <form (ngSubmit)="add()" class="flex flex-col sm:flex-row gap-2 mb-2">
         <input id="add-shop" type="text" name="address" required [(ngModel)]="address" placeholder="shop.bg"
            inputmode="url" [attr.aria-label]="'pages.index-page.try.label' | translate"
            class="min-w-0 flex-1 border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-cyan-500" />
         <button type="submit" [disabled]="adding" class="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold rounded-xl px-6 py-3 transition">
            @if (adding) {
               <div class="spinner spinner-sm inline-block"></div>
            } @else {
               {{ 'pages.shops-page.add' | translate }}
            }
         </button>
      </form>
      @if (adding) {
         <p class="text-slate-500 text-sm" aria-live="polite">{{ 'pages.index-page.try.reading' | translate }}</p>
      }
      @if (errorKey) {
         <p class="text-red-500 text-sm" role="alert">{{ errorKey | translate }}</p>
      }

      @if (loading) {
         <div class="spinner mt-6" id="shops-loading" role="status" [attr.aria-label]="'pages.shops-page.loading' | translate"></div>
      }
      <ul class="mt-6 flex flex-col gap-3" id="shops-list">
         @for (shop of shops; track shop.id) {
            <li>
               <a [routerLink]="['/business', shop.id]" class="glass rounded-2xl p-4 flex items-center gap-4 hover:border-cyan-600 border border-transparent transition-colors">
                  <i class="mdi mdi-storefront-outline text-3xl text-cyan-600" aria-hidden="true"></i>
                  <span class="min-w-0 flex-1">
                     <span class="block font-semibold truncate">{{ shop.name }}</span>
                     <span class="block text-sm text-slate-500 dark:text-slate-400 truncate">
                        {{ shop.hosts[0] }} · {{ 'pages.shops-page.products' | translate: { count: shop.productCount } }}
                     </span>
                  </span>
                  @if (shop.lastWidgetSearchAt) {
                     <span class="text-sm text-emerald-600">{{ 'pages.shops-page.active' | translate }}</span>
                  } @else {
                     <span class="text-sm text-slate-500">{{ 'pages.shops-page.notInstalled' | translate }}</span>
                  }
               </a>
            </li>
         } @empty {
            @if (!loading) {
               <li class="text-slate-500">{{ 'pages.shops-page.empty' | translate }}</li>
            }
         }
      </ul>
   }
</main>
<app-footer />
